// Components.
import Column from 'components/Column'
import AddInquiry from 'components/AddInquiry'
import ComplimentaryEvents from 'components/Section/ComplimentaryEvents'
import Reviews from 'components/Section/Reviews'
import { getCollapsibleOptions } from 'lib/utils/collapsibles'
import ContentArea from './ContentArea'
import Contact from './Contact'
import FeatureList from './FeatureList'
import styles from './EventContent.module.scss'
import Matterport from './Matterport'
import EmbedVideo from './EmbedVideo'
import Links from './Links'

export default function EventContent({ event }) {
  const collapsibles = getCollapsibleOptions(event.fields)

  return (
    <div className={styles.background}>
      <div className="container flex small">
        <Column type="60">
          <div className={styles.contentWrap}>
            <ContentArea
              title={event.title}
              content={event.content}
              titleType={'h1'}
              anchor="yleista"
              isCollapsible={collapsibles.content}
            />
            <Contact
              contact={event.fields.contact_info}
              map={event.fields.map_location}
              owner={event.title}
            />
            <ContentArea
              title="Hinnat"
              content={event.fields.pricing}
              anchor="hinnat"
              price={event.price}
              isCollapsible={collapsibles.pricing}
            />
            <ContentArea
              title="Lisäpalvelut"
              content={event.fields.additional_services}
              anchor="palvelut"
              isCollapsible={collapsibles.additionalServices}
            >
              <FeatureList features={event.features} />
            </ContentArea>
            {event.fields.video_url && event.fields.video_url.length > 0 && (
              <EmbedVideo url={event.fields.video_url} />
            )}
            {event.fields.matterport_url &&
              event.fields.matterport_url.length > 0 && (
                <Matterport url={event.fields.matterport_url} />
              )}
          </div>
        </Column>
        <Column type="40">
          <AddInquiry event={event} />
          <ComplimentaryEvents section={event.fields.complimentary_profiles} />
          <Links links={event.fields.links} />
        </Column>
      </div>
      <Reviews
        section={{ title: 'Arvostelut', reviews: event.fields.reviews }}
      />
    </div>
  )
}
